import Router from "vue-router"
import router from "@/router"
import { commonRouter } from "../router/routes"

export const setStorage = (key, val) => {
  localStorage.setItem(key, typeof val === "object" ? JSON.stringify(val) : val)
}

export const getStorage = (key) => {
  const val = localStorage.getItem(key)
  try {
    return JSON.parse(val)
  } catch (error) {
    return val
  }
}

export const remove = (key) => {
  localStorage.removeItem(key)
}

// keep: 需要保留不清除的 key，可传单个字符串或数组，如 clear("device_token") 或 clear(["device_token"])
export const clear = () => {
  const newRouter = new Router({
    mode: "history",
    routes: commonRouter
  })
  let keep = ['device_token'];
  router.matcher = newRouter.matcher
  const keepList = keep == null ? [] : [].concat(keep)
  Object.keys(localStorage).forEach((key) => {
    if (keepList.indexOf(key) === -1) {
      localStorage.removeItem(key)
    }
  })
}